import { TemplateForm, TemplateFormMode, TemplateFormState } from '../interfaces/template-form';
import { TemplateRawForm } from '../interfaces/template-raw-form';
import { TemplateFormGridFactory } from './templateFormGridFactory';
import { TemplateFormValidationFactory } from './templateFormValidationFactory';

export function TemplateFormFactory(
  rawForm: TemplateRawForm,
  mode: TemplateFormMode
): TemplateForm {
  const { template, name = '' } = rawForm;

  const defaultValues: TemplateFormState = {
    name
  };

  template.fields.forEach(field => {
    const fieldName = field.name;
    defaultValues[fieldName] = 'default_value' in field ? field.default_value : null;
  });

  const formGrids = TemplateFormGridFactory(template, mode);

  return {
    template: formGrids,
    initialValues: {
      ...defaultValues,
      name,
      ...(template.form_values ? { ...template.form_values } : {})
    },
    metadata: {},
    validationSchema: TemplateFormValidationFactory(formGrids)
  };
}
